import { Outlet, createRootRoute } from '@tanstack/react-router';

// TanStackRouterDevtools desactivado: aunque el toggle `VITE_ENABLE_DEVTOOLS`
// existe, se comenta para garantizar que la UI flotante no aparezca en ningún
// entorno (estaba interfiriendo con el layout en /usuarios/$id). Para
// reactivar: descomentar el import + el render condicional.
//
// import { Suspense, lazy } from 'react';
// import { getConfig } from '@/shared/config';
// const TanStackRouterDevtools = getConfig().enableDevtools
//   ? lazy(() =>
//       import('@tanstack/router-devtools').then((mod) => ({
//         default: mod.TanStackRouterDevtools,
//       })),
//     )
//   : null;

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <>
      <Outlet />
      {/* {TanStackRouterDevtools ? (
        <Suspense fallback={null}>
          <TanStackRouterDevtools />
        </Suspense>
      ) : null} */}
    </>
  );
}
